module.exports = __webpack_public_path__ + "img/depmap_svg_V202.90fd3a86.svg";